module.exports = require("@wildboar/x500/src/lib/modules/BasicAccessControl/simplifiedAccessControlScheme.va");